"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnNotified = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CheckBox_1 = require("../../../../../CheckBox");
const ColumnNotified = (props) => {
    const { onChange = () => undefined, disabled, hidden } = props !== null && props !== void 0 ? props : {};
    return {
        id: 'isNotified',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Notified:Title', defaultMessage: 'Notified' })),
        Cell: ({ row }) => {
            var _a;
            return (react_1.default.createElement("div", null,
                react_1.default.createElement(CheckBox_1.CheckBox, { checked: (_a = row.original.isNotified) !== null && _a !== void 0 ? _a : false, onChange: (event) => onChange(row.original, event.target.checked), disabled: disabled })));
        },
        hidden,
    };
};
exports.ColumnNotified = ColumnNotified;
//# sourceMappingURL=index.js.map